export default __webpack_public_path__ + "static/media/CoordinateReferenceSystemCombo.dee79217.less";